import axios from 'axios'

import { useInfringementProcessingStore } from '@/features/infringement/store'
import { routerApolloClient } from '@/shared/graphql/client'
import {
  FileType,
  UploadInfringingFileDocument,
} from '@/shared/graphql/router/graphql'
import { useUserStore } from '@/shared/stores/user'

import { findingFileType, findingTitle, type Finding } from './findings'

export const mediaFileType = (file: File): FileType => {
  const [type, subType] = file.type.split('/')
  if (type === 'audio') return FileType.Audio
  if (type === 'video') return FileType.Video
  if (type === 'image') return FileType.Image
  if (subType === 'pdf') return FileType.Pdf
  if (type === 'text') return FileType.Text
  return FileType.Generic
}

export async function createCheckerReport(
  finding: Finding,
  media: File,
  onProgress: (percentage: number) => void
) {
  if (!finding.fileDataId) throw new Error('This match can’t be reported.')

  const response = await routerApolloClient.mutate({
    mutation: UploadInfringingFileDocument,
    variables: {
      input: { copyrightId: finding.fileDataId, filename: media.name },
    },
  })
  const data = response.data?.uploadInfringingFile
  if (!data?.url || !data.id)
    throw new Error(data?.error?.message || 'Failed to get upload URL')

  const headers = JSON.parse(data.headers) as Record<string, string>
  const formData = new FormData()
  Object.entries(headers)
    .filter(([, value]) => !!value)
    .forEach(([key, value]) => formData.append(key.replace(/_/g, '-'), value))
  formData.append('file', media)

  await axios.post(data.url, formData, {
    onUploadProgress: (event) =>
      onProgress(Math.round((event.progress || 0) * 100)),
  })

  useInfringementProcessingStore().addUploadedProcessingReport({
    copyright: {
      id: finding.fileDataId,
      name: findingTitle(finding),
      type: findingFileType(finding),
      asset: null,
    },
    infringingFile: {
      id: data.id,
      name: media.name,
      type: mediaFileType(media),
    },
  })
  useUserStore().updateUser({ isCreatingReport: true })
}
